import { render, staticRenderFns } from "./oldVersions.vue?vue&type=template&id=3afdd328&scoped=true"
import script from "./oldVersions.vue?vue&type=script&lang=js"
export * from "./oldVersions.vue?vue&type=script&lang=js"
import style0 from "./oldVersions.vue?vue&type=style&index=0&id=3afdd328&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afdd328",
  null
  
)

export default component.exports